import React from "react";
import Header from "../directives/header";
import { Container, Row, Col, Tab, Nav, Card, Button } from "react-bootstrap";
import Footer from "../directives/footer";
import "./css/roadmap.css";

const Roadmap = () => {
  return (
    <>
      <Header />
      <div className="subheader" style={{ background: "url(assets/images/roadmap.svg)", backgroundRepeat: "no-repeat",backgroundSize:" cover" }}>
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2>Roadmap</h2>
              <p>Unitronix is charting a clear and ambitious path for the future, focusing on technological innovation, global reach, and sustainability. Here’s an in-depth look at our roadmap</p>
            </Col>
          </Row>
        </Container>
      </div>
      <section className="launchprocess pt-5">
        <Container className="position-relative">
          <Row className="align-items-center">

            <Col lg={12} className="mb-4">
              <div className="">
                <div className="tabStyle1">
                  <Tab.Container id="left-tabs-example" defaultActiveKey="2024">
                    <Row>
                      <Col sm={12} className="mb-5 pb-3">
                        <Nav variant="pills" className="justify-content-center">
                          <Nav.Item>
                            <Nav.Link eventKey="2024">2024</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="2025">2025</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="2026">2026</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="2027">2027</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="Beyound2027">Beyond 2027</Nav.Link>
                            
                          </Nav.Item>
                        </Nav>
                      </Col>
                      <Col sm={12}>
                        <Tab.Content>
                          <Tab.Pane eventKey="2024">
                            <div>
                              <Col lg={12} className="mb-5 text-center">
                                <div className="heading mb-4">
                                  <h2 className="text-white fw-normal mb-0">
                                    Laying the Foundation
                                  </h2>
                                </div>
                                <p>
                                  The second half of 2024 marks the establishment of Unitronix’s vision, setting the groundwork for a cutting-edge blockchain and decentralized finance (DeFi) venture. This phase is focused on conceptualizing key innovations, assembling a skilled development team, and laying the technical framework for an ecosystem that will enhance accessibility to digital assets and blockchain investments.
                                </p>
                              </Col>
                              <Col lg={12} className="">
                                <Row>
                                  <Col lg={4} md={6} className="">
                                    <Card className="text-center">
                                      <Card.Body className="p-0">
                                        <div>
                                          <div className="blueBox mb-4">
                                            <img src="assets/images/icon/costefficiency.svg" />
                                          </div>
                                          <div className="pt-0 z-1">
                                            <h4 className="text-white">Unitronix Cryptocurrency Portfolio Development</h4>
                                            <p>The concept of a streamlined and accessible cryptocurrency investment model takes shape, offering a simplified entry point for investors.</p>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                  <Col lg={4} md={6} className="mb-5">
                                    <Card className="text-center">
                                      <Card.Body className="p-0">
                                        <div>
                                          <div className="blueBox mb-4">
                                            <img src="assets/images/icon/oversight.svg" />
                                          </div>
                                          <div className="pt-0 z-1">
                                            <h4 className="text-white">Team Formation</h4>
                                            <p>Assembling a team of skilled professionals, including blockchain engineers, software developers, and financial strategists, to drive innovation.</p>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                  <Col lg={4} md={6} className="mb-5">
                                    <Card className="text-center">
                                      <Card.Body className="p-0">
                                        <div>
                                          <div className="blueBox mb-4">
                                            <img src="assets/images/icon/global.svg" />
                                          </div>
                                          <div className="pt-0 z-1">
                                            <h4 className="text-white">Proof of Concept</h4>
                                            <p>Conducting feasibility studies and initial testing to validate key technological approaches and investment strategies.</p>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                  <Col lg={4} md={6} className="mb-5">
                                    <Card className="text-center">
                                      <Card.Body className="p-0">
                                        <div>
                                          <div className="blueBox mb-4">
                                            <img src="assets/images/icon/transparencyTrust.svg" />
                                          </div>
                                          <div className="pt-0 z-1">
                                            <h4 className="text-white">Conceptual Framework</h4>
                                            <p>Defining the Unitronix allocation strategy, focusing on portfolio diversification and risk-optimized exposure to crypto assets.</p>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                  <Col lg={4} md={6} className="mb-5">
                                    <Card className="text-center">
                                      <Card.Body className="p-0">
                                        <div>
                                          <div className="blueBox mb-4">
                                            <img src="assets/images/icon/transparencyTrust.svg" />
                                          </div>
                                          <div className="pt-0 z-1">
                                            <h4 className="text-white">Core Development Phases</h4>
                                            <p>Building the structural foundations of the cryptocurrency portfolio, ensuring efficiency, security, and resilience.</p>

                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                  <Col lg={4} md={6} className="mb-5">
                                    <Card className="text-center">
                                      <Card.Body className="p-0">
                                        <div>
                                          <div className="blueBox mb-4">
                                            <img src="assets/images/icon/transparencyTrust.svg" />
                                          </div>
                                          <div className="pt-0 z-1">
                                            <h4 className="text-white">Strategic Planning</h4>
                                            <p>Outlining a roadmap for technological advancements, regulatory considerations, and long-term market positioning.</p>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  </Col>
                                </Row>

                              </Col>
                            </div>
                            <section className="getintouch">
                              <Container>
                                <Row>
                                  <Col lg={12} className="mb-4 text-center">
                                    <Card>
                                      <Card.Body>
                                        <Row className="getContent justify-content-center align-items-center">
                                          <Col lg={9} className=" text-center">
                                            <div>
                                              <div className="mb-4">
                                                <h2 className=" text-white mb-0">
                                                  Looking Ahead
                                                </h2>
                                              </div>
                                              <p className="mb-4">Unitronix remains committed to continuous innovation and the advancement of blockchain-based financial solutions. As the ecosystem evolves, we will integrate new ideas and push the boundaries of decentralized finance.</p>

                                            </div>
                                          </Col>
                                        </Row>
                                      </Card.Body>
                                      <div>
                                        <div className="rightshadow">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="811"
                                            height="276"
                                            viewBox="0 0 811 276"
                                            fill="none"
                                          >
                                            <g filter="url(#filter0_f_522_5675)">
                                              <path
                                                d="M470.316 274.271C489.094 152.693 662.22 78.5233 799.097 99.6645C935.973 120.806 1031.71 236.502 1012.93 358.08C1004.54 412.402 926.154 430.79 883.506 463.512C830.704 504.024 806.814 551.632 731.095 539.937C661.618 529.206 671.813 466.334 633.13 418.476C595.604 372.049 461.069 334.138 470.316 274.271Z"
                                                fill="#5646AC"
                                              />
                                            </g>
                                            <defs>
                                              <filter
                                                id="filter0_f_522_5675"
                                                x="0.920868"
                                                y="-372.861"
                                                width="1483.3"
                                                height="1383.54"
                                                filterUnits="userSpaceOnUse"
                                                color-interpolation-filters="sRGB"
                                              >
                                                <feFlood
                                                  flood-opacity="0"
                                                  result="BackgroundImageFix"
                                                />
                                                <feBlend
                                                  mode="normal"
                                                  in="SourceGraphic"
                                                  in2="BackgroundImageFix"
                                                  result="shape"
                                                />
                                                <feGaussianBlur
                                                  stdDeviation="234.47"
                                                  result="effect1_foregroundBlur_522_5675"
                                                />
                                              </filter>
                                            </defs>
                                          </svg>
                                        </div>
                                        <div className="particleImg">

                                          <img src="assets/images/particle.gif" />
                                        </div>
                                      </div>
                                    </Card>
                                  </Col>
                                </Row>
                              </Container>
                            </section>
                          </Tab.Pane>
                          <Tab.Pane eventKey="2025">
                            <div>
                              <Col lg={12} className="mb-5 text-center">
                                <div className="heading mb-4">
                                  <h2 className="text-white fw-normal mb-0">
                                    Laying the Foundation for Decentralized Investment
                                  </h2>
                                </div>
                                <p>
                                  This phase marks a crucial period for Unitronix, characterized by substantial progress in our decentralized finance (DeFi) technology and infrastructure. Our efforts have been dedicated to refining the platform’s concept, conducting in-depth testing, and enhancing its functionality and security. Guided by our mission to provide a seamless and secure digital asset investment experience, we have integrated proprietary innovations and advanced technological features. These developments establish a strong foundation for the continued evolution and expansion of the Unitronix DeFi ecosystem.
                                </p>
                              </Col>
                              <Col lg={12} className="">
                                <div className="tabStyle4">
                                  <Tab.Container id="left-tabs-example" defaultActiveKey="jan_mar">
                                    <div className="d-sm-flex">
                                      <Nav variant="pills" className="flex-sm-column">
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="jan_mar">Q1 (Jan – Mar)</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="apr_june">Q2 (Apr – June)</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="jul_sep">Q3 (Jul – Sep)</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="oct_dec">Q4 (Oct – Dec)</Nav.Link>
                                        </Nav.Item>
                                      </Nav>
                                      <Tab.Content>
                                        <Tab.Pane eventKey="jan_mar">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Launch Corporate Website:</b> Establishing Unitronix's online presence to enhance brand visibility.</li>

                                                  <li className="mb-4"><b className="text-white">File Intellectual Property Patent:</b> Securing proprietary blockchain-based financial technologies, such as convertible debt instruments tokenization and lifecycle management</li>

                                                  <li className="mb-4"><b className="text-white">Publish Whitepaper:</b> Outlining the technical and business aspects of Unitronix’s vision, Tokenomics and decentralized finance strategies</li>

                                                  <li className="mb-4"><b className="text-white">Expand Cryptocurrency Portfolio:</b> Increasing exposure to diversified high-growth crypto assets</li>

                                                  <li className="mb-4"><b className="text-white">Decentralized Crypto ETFs:</b> Develop structured exchange-traded crypto investments with Decentralized Autonomous Organizations (DAOs) which enables token holders to participate in governance decisions for investments and ecosystem development</li>

                                                  <li className="mb-4"><b className="text-white">Designing User Interface DeFi Platform:</b> Branding and prioritizing a user-friendly design (UI/UX), making the app appealing to new and experienced users.</li>

                                                  <li className=""><b className="text-white">Strategic Planning:</b> Developing a long-term strategy for the rollout and implementing various wallet features, ensuring a clear roadmap for future development.</li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="apr_june">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Launch Beta version Blockchain Decentralized Finance Platform :</b>  Introducing a secure and transparent investment platform for tokenized real-world assets (RWAs) and decentralized finance (DeFi) investments by integrating smart contract-based tokenization and automated investment mechanisms</li>

                                                  <li className="mb-4"><b className="text-white">File Second Patent Application :</b> Further securing intellectual property</li>

                                                  <li className="mb-4"><b className="text-white">Enhance Cryptocurrency Portfolio algorithm : </b> Optimization Unitronix’s portfolio strategy</li>


                                                </ul>
                                              </div>

                                            </Col>

                                          </div>

                                        </Tab.Pane>
                                        <Tab.Pane eventKey="jul_sep">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Expand Cryptocurrency Portfolio :</b> Adding new high-growth blockchain projects and optimizing risk-adjusted returns</li>
                                                  <li className="mb-4"><b className="text-white">Dapp Beta Launch : </b>Deploying the first iteration of Unitronix’s decentralized application for investors to interact with tokenized assets.</li>
                                                  <li className="mb-4"><b className="text-white">Utility Token Launch :</b> Issuing a native token to facilitate transactions, governance, and incentivization within the Unitronix ecosystem
                                                  </li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="oct_dec">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Optimize Platform and Dapp :</b> Enhancing the usability, security, and efficiency of the decentralized finance platform.</li>
                                                  <li className="mb-4"><b className="text-white">User Experience Upgrades: </b>Implementation of a more intuitive user interface, catering to both novice and expert users</li>
                                                  <li className="mb-4"><b className="text-white">Interoperability Features:</b> Integration with multiple blockchain protocols to enhance cross-chain compatibility and broaden the platform’s ecosystem
                                                  </li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                      </Tab.Content>
                                    </div>
                                  </Tab.Container>
                                </div>
                              </Col>
                            </div>

                          </Tab.Pane>
                          <Tab.Pane eventKey="2026">
                            <div>
                             
                              <Col lg={12} className="">
                                <div className="tabStyle4">
                                  <Tab.Container id="left-tabs-example" defaultActiveKey="jan_mar">
                                    <div className="d-sm-flex">
                                      <Nav variant="pills" className="flex-sm-column">
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="jan_mar">Q1 (Jan – Mar)</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="apr_june">Q2 (Apr – June)</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="jul_sep">Q3 (Jul – Sep)</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="oct_dec">Q4 (Oct – Dec)</Nav.Link>
                                        </Nav.Item>
                                      </Nav>
                                      <Tab.Content>
                                        <Tab.Pane eventKey="jan_mar">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Expand Asset Offerings :</b>  Integrating tokenized financial instruments, including convertible debt, SAFEs, and revenue-based financing.</li>
                                                  <li className="mb-4"><b className="text-white">Scale Operations :</b> Expanding the DeFi platform’s infrastructure to support institutional and retail investors.
                                                  </li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="apr_june">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Secure International Partnerships :</b> Forming strategic alliances with financial institutions, crypto projects, and regulatory bodies for market expansion.</li>
                                                  <li className="mb-4"><b className="text-white">Develop Institutional : </b>Grade DeFi Solutions: enhancing the adoption of tokenized securities by hedge funds and asset managers</li>

                                                </ul>
                                              </div>

                                            </Col>

                                          </div>

                                        </Tab.Pane>
                                        <Tab.Pane eventKey="jul_sep">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Expand Cryptocurrency Portfolio :</b> Continuously adding new blockchain-based assets and innovative financial products to maximize investor opportunities.</li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="oct_dec">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Preparation for Nasdaq Listing :</b> Finalizing regulatory and financial compliance for public market expansion.</li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                      </Tab.Content>
                                    </div>
                                  </Tab.Container>
                                </div>
                              </Col>
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="2027">
                            <div>
                             
                              <Col lg={12} className="">
                                <div className="tabStyle4">
                                  <Tab.Container id="left-tabs-example" defaultActiveKey="jan_mar">
                                    <div className="d-sm-flex">
                                      <Nav variant="pills" className="flex-sm-column">
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="jan_mar">Q1 (Jan – Mar)</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="mb-3">
                                          <Nav.Link eventKey="apr_june">Q2 (Apr – June)</Nav.Link>
                                        </Nav.Item>
                                      
                                      </Nav>
                                      <Tab.Content>
                                        <Tab.Pane eventKey="jan_mar">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Nasdaq Listing :</b> Elevating Unitronix to a global financial platform by going public on Nasdaq.</li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="apr_june">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Scale Operations over $1B in Tokenized Asset :</b> Expanding the platform to facilitate large-scale investments and liquidity management.</li>
                                                  <li className="mb-4"><b className="text-white">Increase Cryptocurrency Portfolio :</b> Strengthening Unitronix’s position as a premier blockchain investment hub.

                                                  </li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>

                                        </Tab.Pane>
                                        {/* ------------------ */}
                                        <Tab.Pane eventKey="jul_sep">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Advanced Financial Products :</b> Introducing hybrid financial models, including revenue-sharing tokens and staking-based convertible equity.</li>
                                                  <li className="mb-4"><b className="text-white">Quantum-Resistant Cryptography :</b> Future-proofing blockchain security with cutting-edge encryption technologies.</li>
                                                  <li className="mb-4"><b className="text-white">Carbon-Neutral Blockchain Infrastructure :</b>Committing to sustainability by integrating eco-friendly blockchain solutions.
                                                  </li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="oct_dec">
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="ms-3">
                                                <ul className="mb-0">
                                                  <li className="mb-4"><b className="text-white">Launch Corporate Website:</b> Establishing Unitronix's online presence to enhance brand visibility.</li>

                                                  <li className="mb-4"><b className="text-white">File Intellectual Property Patent:</b> Securing proprietary blockchain-based financial technologies, such as convertible debt instruments tokenization and lifecycle management</li>

                                                  <li className="mb-4"><b className="text-white">Publish Whitepaper:</b> Outlining the technical and business aspects of Unitronix’s vision, Tokenomics and decentralized finance strategies</li>

                                                  <li className="mb-4"><b className="text-white">Expand Cryptocurrency Portfolio:</b> Increasing exposure to diversified high-growth crypto assets</li>

                                                  <li className="mb-4"><b className="text-white">Decentralized Crypto ETFs:</b> Develop structured exchange-traded crypto investments with Decentralized Autonomous Organizations (DAOs) which enables token holders to participate in governance decisions for investments and ecosystem development</li>

                                                  <li className="mb-4"><b className="text-white">Designing User Interface DeFi Platform:</b> Branding and prioritizing a user-friendly design (UI/UX), making the app appealing to new and experienced users.</li>

                                                  <li className=""><b className="text-white">Strategic Planning:</b> Developing a long-term strategy for the rollout and implementing various wallet features, ensuring a clear roadmap for future development.</li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                        </Tab.Pane>
                                      </Tab.Content>
                                    </div>
                                  </Tab.Container>
                                </div>
                              </Col>
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Beyound2027">
                            <div>
                              <Col lg={12} className="">
                                <div className="tabStyle4">
                                    <div className="">
                                       
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="">
                                                <ul className="mb-0 list-unstyled ps-0">
                                                  <li className="mb-4"><h5 className="text-white">Advanced Financial Products<br/></h5> Introducing hybrid financial models, including revenue-sharing tokens and staking-based convertible equity.</li>
                                                  <li className="mb-4"><h5 className="text-white">Quantum-Resistant Cryptography<br/></h5> Future-proofing blockchain security with cutting-edge encryption technologies.</li>
                                                  <li className="mb-4"><h5 className="text-white">Carbon-Neutral Blockchain Infrastructure<br/></h5>Committing to sustainability by integrating eco-friendly blockchain solutions.
                                                  </li>
                                                </ul>
                                              </div>

                                            </Col>

                                          </div>
                                          <div>
                                            <Col lg={12} className="">
                                              <div className="">
                                                <p>This roadmap ensures that <b className="text-white">Unitronix Corp.</b> remains at the forefront of <b className="text-white">decentralized finance, tokenized asset management, and AI-driven crypto investments,</b> while progressing toward a <b className="text-white">Nasdaq listing and global expansion.</b></p>
                                              </div>

                                            </Col>

                                          </div>
                                    </div>
                                </div>
                              </Col>
                            </div>
                          </Tab.Pane>
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>
                </div>
              </div>
            </Col>
            {/* <Col lg={12} className="mb-4">
            <div>
                <div className="heading mb-4">
                  <h4 className="text-white fw-normal mb-0">Long-Term Vision</h4>
                </div>
                <p>By 2030, Unitronix aims to be a global leader in decentralized finance, offering a comprehensive ecosystem that bridges the gap between traditional financial systems and innovative blockchain solutions. This vision includes:</p>
            <div>
              <ul>
                <li className="mb-2">Democratizing access to financial tools for underbanked populations.</li>
                <li className="mb-2">Creating an entirely carbon-neutral blockchain infrastructure.</li>
                <li className="mb-2">Scaling our platform to support +1 billion of dollars in tokenized assets.</li>
              </ul>
            </div>
            <p>Stay connected to witness our evolution by subscribing to our newsletter and becoming an active member of the Unitronix community. Your journey with us is just beginning.</p>
            </div>
            </Col> */}
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Roadmap;
